export const InfoMessage = {
  VALID: `Промокод применен.`,
  INVALID: `Недействительный промокод.`,
  EMPTY: `Поле не должно быть пустым.`,
  REMOVED: `Промокод удалён.`
};

export const APPLIED_TEXT = `Удалить промокод`;
